import { Fab, Stack } from '@mui/material'
import { useState } from 'react'
import { Icons } from 'utoniq-ui'

import {
  ConsoleEventCollectionSelectConnectionFragment,
  Maybe,
} from '@/clients/utoniq-core/schema'
import { SelectCollectionModal } from '@/components/pages/ConsoleEventDetail/template/components/SelectCollectionModal'
import { styles } from '@/components/styles'
import { Cell } from '@/core/architecture'

type CreateCollectionActionSheetCellProps = {
  artistId: string
  isShow: boolean
  loading: boolean
  hasNextPage: boolean
  addingCollection: boolean
  collections: Maybe<ConsoleEventCollectionSelectConnectionFragment>
  onFetchSelectCollection: () => Promise<void>
  onFetchMoreSelectCollection: () => Promise<void>
  onAddCollectionsToEvent: (collectionIds: string[]) => Promise<void>
}
export const CreateCollectionActionSheetCell: Cell<CreateCollectionActionSheetCellProps> =
  ({ artistId, isShow, onFetchSelectCollection, ...props }) => {
    const [open, setOpen] = useState<boolean>(false)

    if (!isShow) return null

    return (
      <>
        <Stack direction="row-reverse">
          <Stack
            sx={{
              position: 'fixed',
              bottom: 16,
              zIndex: 5,
              maxWidth: 600,
              margin: '0 auto',
              px: 4,
              pb: styles.safeAreaBottom,
            }}
          >
            <Fab
              size="medium"
              color="primary"
              onClick={() => {
                onFetchSelectCollection()
                setOpen(true)
              }}
            >
              <Icons.ThinPlus fontSize="medium" sx={{ color: 'white' }} />
            </Fab>
          </Stack>
        </Stack>
        <SelectCollectionModal
          artistId={artistId}
          open={open}
          onClose={() => setOpen(false)}
          {...props}
        />
      </>
    )
  }
